const chartWeek = (a, b) => ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day, i) => ({ day, calls: a[i], resolved: b[i] }));
const INDUSTRY_DATA = {
  doctor: {
    id: "doctor",
    label: "Doctor",
    emoji: "\u{1FA7A}",
    color: "#6f5cf7",
    bgLight: "#f4f2ff",
    tagline: "AI for Healthcare Professionals",
    supportHeadline: "AI Medical Receptionist",
    supportFeatures: ["24\xD77 Appointment Booking", "Patient Follow-up Calls", "Medical History Collection", "Insurance Verification", "Prescription Reminders", "Multi-language Voice AI", "WhatsApp & SMS Alerts", "Doctor Calendar Sync"],
    surveillanceHeadline: "Smart Clinic Surveillance",
    surveillanceFeatures: ["Waiting Room Analytics", "Queue Heatmaps", "Intrusion Detection", "Unauthorized Zone Alerts", "Patient Fall Detection", "Staff Attendance Tracking", "Smart Door Access", "Emergency Alert System"],
    workflow: [
      { label: "Patient Arrives", icon: "\u{1F9D1}\u200D\u2695\uFE0F", desc: "Patient initiates via call, WhatsApp, or walk-in" },
      { label: "Voice AI Greets", icon: "\u{1F399}\uFE0F", desc: "AI receptionist collects name, concern & insurance" },
      { label: "Appointment Booked", icon: "\u{1F4C5}", desc: "Slot confirmed & synced to doctor's calendar" },
      { label: "Reminder Sent", icon: "\u{1F514}", desc: "SMS + WhatsApp reminder 24h & 1h before visit" },
      { label: "Consultation", icon: "\u{1F48A}", desc: "Doctor conducts session; AI logs summary" },
      { label: "Follow-up", icon: "\u{1F4CB}", desc: "Automated post-visit care plan & next appointment" },
      { label: "Feedback Collected", icon: "\u2B50", desc: "AI collects NPS score and improvement data" }
    ],
    metrics: [
      { label: "Appointments Today", value: "248", sub: "+18% vs last week", positive: true, color: "#6f5cf7" },
      { label: "AI Calls Handled", value: "1,842", sub: "98.2% resolved", positive: true, color: "#8b5cf6" },
      { label: "Patient Satisfaction", value: "4.9\u2605", sub: "From 312 reviews", positive: true, color: "#10b981" },
      { label: "Avg Response Time", value: "8 sec", sub: "\u221262% vs manual", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([180, 210, 248, 190, 320, 290, 270], [165, 195, 238, 182, 305, 278, 262]),
    testimonial: {
      name: "Dr. Priya Sharma",
      role: "Chief of Medicine",
      company: "Apollo Clinics, Delhi",
      quote: "Orryworx AI reduced our missed appointments by 71% and our receptionist now focuses on in-clinic patients. The voice AI handles 95% of all booking calls flawlessly.",
      avatar: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=100&h=100&fit=crop&auto=format"
    }
  },
  dentist: {
    id: "dentist",
    label: "Dentist",
    emoji: "\u{1F9B7}",
    color: "#06b6d4",
    bgLight: "#ecfeff",
    tagline: "AI for Dental Practices",
    supportHeadline: "AI Dental Receptionist",
    supportFeatures: ["Appointment Booking & Rescheduling", "Treatment Reminders", "Insurance Pre-authorization", "Post-procedure Follow-up", "Whitening & Cleaning Promos", "Patient Records Collection", "Multi-doctor Scheduling", "SMS & WhatsApp Confirmations"],
    surveillanceHeadline: "Dental Clinic Smart Surveillance",
    surveillanceFeatures: ["Waiting Room Queue Tracking", "Sterilization Zone Monitoring", "After-hours Intrusion Detection", "Patient Flow Heatmaps", "Staff Presence Verification", "Smart Access Control", "Emergency Alerts", "Compliance Recording"],
    workflow: [
      { label: "Patient Calls", icon: "\u{1F4DE}", desc: "Call, WhatsApp, or web booking request" },
      { label: "AI Screens", icon: "\u{1F916}", desc: "Collects symptoms, last visit, insurance details" },
      { label: "Slot Confirmed", icon: "\u{1F4C5}", desc: "Appointment booked with specific dentist" },
      { label: "Pre-visit Reminder", icon: "\u{1F514}", desc: "24h + 2h automated SMS/WhatsApp reminder" },
      { label: "Treatment", icon: "\u{1F9B7}", desc: "Dentist performs procedure; AI logs notes" },
      { label: "Care Plan Sent", icon: "\u{1F4CB}", desc: "Post-treatment instructions auto-messaged" },
      { label: "Feedback Captured", icon: "\u2B50", desc: "Review request sent 24h after visit" }
    ],
    metrics: [
      { label: "Appointments Booked", value: "186", sub: "+24% this month", positive: true, color: "#06b6d4" },
      { label: "AI Calls Handled", value: "1,240", sub: "97.1% resolved", positive: true, color: "#8b5cf6" },
      { label: "Patient Satisfaction", value: "4.8\u2605", sub: "From 203 reviews", positive: true, color: "#10b981" },
      { label: "No-show Rate", value: "4.2%", sub: "\u221268% vs before AI", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([140, 160, 186, 170, 220, 200, 190], [128, 150, 178, 162, 210, 193, 182]),
    testimonial: {
      name: "Dr. Arjun Mehta",
      role: "Founder & Lead Dentist",
      company: "SmileFirst Dental, Mumbai",
      quote: "Our no-show rate dropped from 22% to 4% in one month. The AI receptionist handles everything\u2014confirmations, cancellations, even treatment questions.",
      avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=100&h=100&fit=crop&auto=format"
    }
  },
  hospital: {
    id: "hospital",
    label: "Hospital",
    emoji: "\u{1F3E5}",
    color: "#ef4444",
    bgLight: "#fef2f2",
    tagline: "AI for Hospitals & Health Systems",
    supportHeadline: "Hospital AI Command Center",
    supportFeatures: ["Multi-department Routing", "Emergency Triage Chatbot", "OPD Queue Management", "Bed Availability Alerts", "Discharge Planning AI", "Visitor Management", "Insurance Claims Assistance", "Staff Paging System"],
    surveillanceHeadline: "Hospital Smart Security",
    surveillanceFeatures: ["ICU & Ward Monitoring", "Infant Security Alerts", "Unauthorized Access Detection", "Medication Storage Surveillance", "Fire & Emergency Detection", "Crowd Analytics", "Staff Tracking", "Real-time Incident Reporting"],
    workflow: [
      { label: "Patient Entry", icon: "\u{1F3E5}", desc: "Walk-in or ambulance arrival registered" },
      { label: "AI Triage", icon: "\u{1F6A8}", desc: "AI assesses urgency level and routes appropriately" },
      { label: "Department Assigned", icon: "\u{1F3E2}", desc: "Patient directed to correct ward or specialist" },
      { label: "Doctor Notified", icon: "\u{1F4F2}", desc: "Attending physician alerted with patient summary" },
      { label: "Treatment", icon: "\u{1F489}", desc: "Care delivered; AI monitors and logs vitals" },
      { label: "Discharge Planning", icon: "\u{1F4CB}", desc: "AI prepares discharge summary & home-care plan" },
      { label: "Follow-up Scheduled", icon: "\u{1F4C5}", desc: "Next appointment booked before patient leaves" }
    ],
    metrics: [
      { label: "OPD Patients Today", value: "1,284", sub: "+11% vs last week", positive: true, color: "#ef4444" },
      { label: "AI Interactions", value: "8,400", sub: "99.1% resolved", positive: true, color: "#8b5cf6" },
      { label: "Avg Wait Time", value: "6 min", sub: "\u221274% reduction", positive: true, color: "#10b981" },
      { label: "Bed Utilization", value: "87%", sub: "Optimally managed", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([900, 1050, 1284, 1100, 1500, 1400, 1320], [840, 1e3, 1250, 1060, 1460, 1350, 1280]),
    testimonial: {
      name: "Dr. Kavita Nair",
      role: "Hospital Administrator",
      company: "Lilavati Hospital, Mumbai",
      quote: "With Orryworx AI, we automated 80% of our OPD workflows. Patient wait times dropped by 74% and our staff now focuses on care, not paperwork.",
      avatar: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=100&h=100&fit=crop&auto=format"
    }
  },
  bus: {
    id: "bus",
    label: "Bus Operator",
    emoji: "\u{1F68C}",
    color: "#f59e0b",
    bgLight: "#fffbeb",
    tagline: "AI for Bus & Transport Operators",
    supportHeadline: "AI Passenger Support",
    supportFeatures: ["Route & Schedule Queries", "Ticket Booking via Voice", "Real-time Bus Tracking", "Delay Notifications", "Lost & Found AI", "Multi-language Support", "WhatsApp Integration", "Fleet Management Alerts"],
    surveillanceHeadline: "Fleet & Depot Surveillance",
    surveillanceFeatures: ["Passenger Counting", "Driver Behavior Monitoring", "On-board CCTV Analytics", "Depot Security", "Unauthorized Person Detection", "Night Route Monitoring", "Incident Recording", "Dashboard Alerts"],
    workflow: [
      { label: "Passenger Query", icon: "\u{1F9D1}\u200D\u{1F4BC}", desc: "Call, WhatsApp, or app inquiry about route/ticket" },
      { label: "Voice AI Responds", icon: "\u{1F399}\uFE0F", desc: "AI provides real-time schedule & fare info" },
      { label: "Ticket Booked", icon: "\u{1F3AB}", desc: "Seat reserved; payment processed instantly" },
      { label: "GPS Tracking", icon: "\u{1F4CD}", desc: "Live bus location shared with passenger" },
      { label: "Journey Alert", icon: "\u{1F514}", desc: "Boarding reminder & stop notifications sent" },
      { label: "Journey Complete", icon: "\u2705", desc: "Arrival confirmed; receipt sent automatically" },
      { label: "Feedback Collected", icon: "\u2B50", desc: "Passenger rates experience via WhatsApp" }
    ],
    metrics: [
      { label: "Passengers Served", value: "12,400", sub: "+31% this month", positive: true, color: "#f59e0b" },
      { label: "AI Queries Handled", value: "38,200", sub: "96.8% automated", positive: true, color: "#8b5cf6" },
      { label: "On-time Performance", value: "94.2%", sub: "+8% improvement", positive: true, color: "#10b981" },
      { label: "Revenue Saved", value: "\u20B94.2L", sub: "Monthly support cost", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([9800, 11200, 12400, 10800, 14800, 13600, 12900], [9200, 10600, 11900, 10300, 14100, 13e3, 12400]),
    testimonial: {
      name: "Rajesh Patel",
      role: "Operations Director",
      company: "Shree Travels, Gujarat",
      quote: "AI handles 38,000 passenger queries per month automatically. Our booking rate went up 31% and we've completely eliminated manual query handling on routes.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&auto=format"
    }
  },
  salon: {
    id: "salon",
    label: "Salon",
    emoji: "\u2702\uFE0F",
    color: "#ec4899",
    bgLight: "#fdf2f8",
    tagline: "AI for Salons & Beauty Studios",
    supportHeadline: "AI Beauty Receptionist",
    supportFeatures: ["Appointment Booking & Rescheduling", "Stylist Availability Check", "Service Menu Queries", "WhatsApp Confirmations", "Loyalty Points Queries", "Offer & Promo Automation", "Customer Follow-up", "Birthday & Occasion Reminders"],
    surveillanceHeadline: "Smart Salon Security",
    surveillanceFeatures: ["Footfall Counting", "Chair Utilization Analytics", "Theft Prevention Alerts", "After-hours Security", "Staff Attendance Tracking", "VIP Customer Detection", "Peak Hour Heatmaps", "Incident Recording"],
    workflow: [
      { label: "Customer Contacts", icon: "\u{1F4AC}", desc: "WhatsApp, call, or walk-in inquiry" },
      { label: "AI Receptionist", icon: "\u{1F916}", desc: "AI checks stylist availability & services" },
      { label: "Appointment Set", icon: "\u{1F4C5}", desc: "Booking confirmed with preferred stylist" },
      { label: "Stylist Assigned", icon: "\u{1F487}", desc: "Specific stylist notified via app" },
      { label: "Reminder Sent", icon: "\u{1F514}", desc: "Day-before + 2h prior WhatsApp reminder" },
      { label: "Service Delivered", icon: "\u2728", desc: "Customer served; AI logs service & spend" },
      { label: "Feedback & Offer", icon: "\u{1F381}", desc: "Review request + personalized next-visit offer" }
    ],
    metrics: [
      { label: "Bookings This Month", value: "1,840", sub: "+44% vs last month", positive: true, color: "#ec4899" },
      { label: "AI Messages Handled", value: "14,600", sub: "98.4% automated", positive: true, color: "#8b5cf6" },
      { label: "Client Satisfaction", value: "4.9\u2605", sub: "From 820 reviews", positive: true, color: "#10b981" },
      { label: "No-show Rate", value: "3.1%", sub: "\u221271% reduction", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([1400, 1600, 1840, 1700, 2200, 2e3, 1900], [1320, 1520, 1770, 1630, 2120, 1940, 1830]),
    testimonial: {
      name: "Simran Kaur",
      role: "Owner",
      company: "Glow Studio, Chandigarh",
      quote: "My salon went from 40% no-show rate to 3% after deploying the AI receptionist. Customers love getting instant WhatsApp replies and we've 2x'd our monthly bookings.",
      avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&auto=format"
    }
  },
  hotel: {
    id: "hotel",
    label: "Hotel",
    emoji: "\u{1F3E8}",
    color: "#0ea5e9",
    bgLight: "#f0f9ff",
    tagline: "AI for Hotels & Hospitality",
    supportHeadline: "AI Hotel Concierge",
    supportFeatures: ["Room Booking & Availability", "Check-in / Check-out Automation", "In-room Service Requests", "Restaurant Reservation", "Local Recommendations", "Housekeeping Scheduling", "Loyalty Program Management", "Complaint Resolution AI"],
    surveillanceHeadline: "Hotel Smart Surveillance",
    surveillanceFeatures: ["Lobby & Corridor Monitoring", "Pool & Spa Safety Alerts", "Unauthorized Room Access Detection", "Car Park Surveillance", "VIP Guest Recognition", "Occupancy Heatmaps", "Incident Logging", "Fire & Emergency Response"],
    workflow: [
      { label: "Guest Inquiry", icon: "\u{1F6CE}\uFE0F", desc: "Call, chat, or booking platform inquiry" },
      { label: "AI Concierge", icon: "\u{1F916}", desc: "AI checks availability, upgrades & amenities" },
      { label: "Room Booked", icon: "\u{1F6CF}\uFE0F", desc: "Confirmation sent with check-in details" },
      { label: "Pre-arrival Message", icon: "\u2708\uFE0F", desc: "Personalized welcome + preferences collected" },
      { label: "Check-in", icon: "\u{1F511}", desc: "Digital check-in processed; room key dispatched" },
      { label: "Stay Experience", icon: "\u2B50", desc: "AI handles all in-stay requests 24\xD77" },
      { label: "Checkout & Review", icon: "\u{1F4CB}", desc: "Bill settled; feedback + return offer sent" }
    ],
    metrics: [
      { label: "Bookings This Week", value: "384", sub: "+22% vs last week", positive: true, color: "#0ea5e9" },
      { label: "AI Concierge Requests", value: "6,200", sub: "97.3% resolved", positive: true, color: "#8b5cf6" },
      { label: "Guest Satisfaction", value: "4.8\u2605", sub: "From 1,240 reviews", positive: true, color: "#10b981" },
      { label: "Revenue per Room", value: "+28%", sub: "Upsell via AI", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([280, 320, 384, 310, 480, 460, 420], [265, 308, 370, 298, 460, 444, 405]),
    testimonial: {
      name: "Anand Krishnan",
      role: "General Manager",
      company: "The Grand Residency, Bengaluru",
      quote: "Guest satisfaction scores hit an all-time high. The AI concierge handles every request instantly\u2014from room service to local sightseeing\u2014and our staff focuses purely on personalizing the stay.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&auto=format"
    }
  },
  school: {
    id: "school",
    label: "School",
    emoji: "\u{1F3EB}",
    color: "#10b981",
    bgLight: "#f0fdf4",
    tagline: "AI for Schools & Colleges",
    supportHeadline: "AI Academic Assistant",
    supportFeatures: ["Admissions Inquiry Handling", "Fee Payment Reminders", "Attendance Notifications", "Exam Schedule Queries", "Parent Communication AI", "Leave Application Chatbot", "Transport Route Queries", "Scholarship Information"],
    surveillanceHeadline: "School Safety Surveillance",
    surveillanceFeatures: ["Student Entry/Exit Tracking", "Unauthorized Visitor Detection", "Bus Arrival Monitoring", "Campus Perimeter Security", "Classroom Occupancy", "After-hours Intrusion Alerts", "Bully Detection Analytics", "Emergency Lockdown System"],
    workflow: [
      { label: "Parent Inquiry", icon: "\u{1F4DE}", desc: "Admission, fee, or academic query received" },
      { label: "AI Responds", icon: "\u{1F916}", desc: "Instant 24\xD77 answers to FAQs & queries" },
      { label: "Admission Processed", icon: "\u{1F4DD}", desc: "Documents collected; seat confirmed via AI" },
      { label: "Parent Onboarded", icon: "\u{1F468}\u200D\u{1F469}\u200D\u{1F467}", desc: "School app, transport & schedule info shared" },
      { label: "Attendance Tracked", icon: "\u{1F4CA}", desc: "Daily attendance SMS sent to parents" },
      { label: "Fee Reminder", icon: "\u{1F4B3}", desc: "Automated payment reminders 7 days prior" },
      { label: "Progress Report", icon: "\u{1F4CB}", desc: "AI-generated report card shared with parents" }
    ],
    metrics: [
      { label: "Inquiries This Month", value: "2,840", sub: "+38% conversion", positive: true, color: "#10b981" },
      { label: "Parent Messages Handled", value: "18,400", sub: "99% automated", positive: true, color: "#8b5cf6" },
      { label: "Fee Collection Rate", value: "96.8%", sub: "+18% improvement", positive: true, color: "#10b981" },
      { label: "Parent Satisfaction", value: "4.7\u2605", sub: "From 640 reviews", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([2100, 2400, 2840, 2600, 3400, 3200, 3100], [1980, 2280, 2700, 2480, 3260, 3060, 2960]),
    testimonial: {
      name: "Principal Meena Verma",
      role: "Principal",
      company: "DPS International, Noida",
      quote: "Orryworx AI handles all our parent communication automatically\u2014fee reminders, attendance alerts, exam schedules. Staff workload dropped 60% while parent satisfaction went up.",
      avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&auto=format"
    }
  },
  retail: {
    id: "retail",
    label: "Retail Store",
    emoji: "\u{1F6D2}",
    color: "#f97316",
    bgLight: "#fff7ed",
    tagline: "AI for Retail & E-commerce",
    supportHeadline: "AI Retail Assistant",
    supportFeatures: ["Product Availability Queries", "Order Tracking & Updates", "Return & Refund Processing", "Personalized Recommendations", "Loyalty Points Chatbot", "Flash Sale Announcements", "Complaint Resolution", "WhatsApp Commerce"],
    surveillanceHeadline: "Retail Store Surveillance",
    surveillanceFeatures: ["Shoplifting Detection", "Customer Footfall Analytics", "High-value Item Monitoring", "Queue Length Management", "Heatmap of Popular Zones", "Staff Behavior Analytics", "After-hours Security", "Loss Prevention Reports"],
    workflow: [
      { label: "Customer Visits", icon: "\u{1F6D2}", desc: "In-store, online, or WhatsApp shopping inquiry" },
      { label: "AI Assists", icon: "\u{1F916}", desc: "Product search, price check, availability query" },
      { label: "Purchase Guided", icon: "\u{1F4B3}", desc: "AI recommends; customer adds to cart" },
      { label: "Order Confirmed", icon: "\u{1F4E6}", desc: "Order placed; fulfillment triggered" },
      { label: "Delivery Tracked", icon: "\u{1F69A}", desc: "Real-time updates sent via WhatsApp" },
      { label: "Delivered", icon: "\u2705", desc: "Delivery confirmed; invoice sent" },
      { label: "Review & Loyalty", icon: "\u{1F381}", desc: "Review request + loyalty points credited" }
    ],
    metrics: [
      { label: "Daily Transactions", value: "4,820", sub: "+29% this quarter", positive: true, color: "#f97316" },
      { label: "AI Interactions", value: "28,600", sub: "97.6% automated", positive: true, color: "#8b5cf6" },
      { label: "Conversion Rate", value: "38.4%", sub: "+14% vs baseline", positive: true, color: "#10b981" },
      { label: "Shrinkage Reduction", value: "\u221262%", sub: "Via AI surveillance", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([3800, 4200, 4820, 4400, 5800, 5600, 5200], [3560, 3980, 4620, 4200, 5560, 5360, 4980]),
    testimonial: {
      name: "Vikram Joshi",
      role: "COO",
      company: "FreshMart Retail, Pune",
      quote: "Shrinkage is down 62% and our customer satisfaction is at an all-time high. The AI handles 28,000 customer messages a month\u2014something our 5-person team could never do.",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&auto=format"
    }
  },
  bank: {
    id: "bank",
    label: "Bank",
    emoji: "\u{1F3E6}",
    color: "#6f5cf7",
    bgLight: "#f4f2ff",
    tagline: "AI for Banks & Financial Institutions",
    supportHeadline: "AI Banking Assistant",
    supportFeatures: ["Account Balance Queries", "Transaction Dispute Resolution", "Loan Eligibility Chatbot", "KYC Document Collection", "Credit Card Support", "Branch & ATM Locator", "Fraud Alert Notifications", "Financial Advisory AI"],
    surveillanceHeadline: "Bank Security Intelligence",
    surveillanceFeatures: ["ATM Surveillance & Skimmer Detection", "Branch Perimeter Security", "Cash Vault Monitoring", "Suspicious Behavior Detection", "Face Recognition at Entry", "Crowd Analytics", "Robbery Alert System", "Compliance Recording"],
    workflow: [
      { label: "Customer Query", icon: "\u{1F4B3}", desc: "Call, chat, or app-based banking query" },
      { label: "Identity Verified", icon: "\u{1F510}", desc: "AI verifies identity via OTP & voice biometric" },
      { label: "Request Processed", icon: "\u26A1", desc: "Transaction, query, or complaint handled" },
      { label: "Compliance Check", icon: "\u2705", desc: "AI ensures all regulatory requirements met" },
      { label: "Action Completed", icon: "\u{1F4CA}", desc: "Transfer, statement, or advisory delivered" },
      { label: "Fraud Monitoring", icon: "\u{1F6E1}\uFE0F", desc: "Continuous AI monitoring for anomalies" },
      { label: "Report Generated", icon: "\u{1F4CB}", desc: "Interaction log & summary sent to customer" }
    ],
    metrics: [
      { label: "Daily Queries Handled", value: "48,200", sub: "+41% YoY", positive: true, color: "#6f5cf7" },
      { label: "Fraud Prevented", value: "\u20B92.8Cr", sub: "Last 30 days", positive: true, color: "#8b5cf6" },
      { label: "Resolution Time", value: "42 sec", sub: "\u221284% vs agent", positive: true, color: "#10b981" },
      { label: "Customer Satisfaction", value: "4.8\u2605", sub: "From 8,400 reviews", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([38e3, 42e3, 48200, 44e3, 58e3, 54e3, 52e3], [35600, 39800, 46200, 42e3, 55600, 51600, 49800]),
    testimonial: {
      name: "Nisha Agarwal",
      role: "Head of Digital Banking",
      company: "IndusFirst Bank",
      quote: "Our AI handles 48,000 daily banking queries with 99.2% accuracy. Customer wait times dropped from 12 minutes to 42 seconds. It's transformed our service completely.",
      avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&auto=format"
    }
  },
  restaurant: {
    id: "restaurant",
    label: "Restaurant",
    emoji: "\u{1F37D}\uFE0F",
    color: "#dc2626",
    bgLight: "#fef2f2",
    tagline: "AI for Restaurants & Food Chains",
    supportHeadline: "AI Restaurant Host",
    supportFeatures: ["Table Reservation via Voice", "Menu Queries & Recommendations", "Online Order Management", "Special Occasion Requests", "Delivery Status Updates", "Allergy & Dietary AI", "VIP Guest Recognition", "WhatsApp Order Taking"],
    surveillanceHeadline: "Restaurant Safety & Analytics",
    surveillanceFeatures: ["Kitchen Hygiene Monitoring", "Table Turnover Analytics", "Theft Prevention", "Staff Movement Tracking", "Dine-in Occupancy Heatmaps", "Delivery Zone Monitoring", "After-hours Security", "Health Compliance Alerts"],
    workflow: [
      { label: "Guest Contacts", icon: "\u{1F37D}\uFE0F", desc: "Call, WhatsApp, or app reservation request" },
      { label: "AI Host Responds", icon: "\u{1F916}", desc: "Checks table availability & special requests" },
      { label: "Table Reserved", icon: "\u{1FA91}", desc: "Booking confirmed; dietary prefs noted" },
      { label: "Pre-arrival Message", icon: "\u{1F4F1}", desc: "Directions + welcome message sent" },
      { label: "Order Taken", icon: "\u{1F4CB}", desc: "AI assists with menu & recommendations" },
      { label: "Meal Delivered", icon: "\u{1F35C}", desc: "Kitchen notified; service coordinated" },
      { label: "Review & Return Offer", icon: "\u2764\uFE0F", desc: "Thank you + discount for next visit" }
    ],
    metrics: [
      { label: "Covers Per Day", value: "480", sub: "+36% vs last month", positive: true, color: "#dc2626" },
      { label: "AI Reservations", value: "3,840", sub: "94% via AI", positive: true, color: "#8b5cf6" },
      { label: "Table Turnover", value: "3.2\xD7", sub: "+0.8\xD7 improvement", positive: true, color: "#10b981" },
      { label: "Food Waste Reduction", value: "\u221238%", sub: "Via predictive AI", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([360, 400, 480, 420, 600, 580, 520], [338, 380, 462, 404, 580, 560, 500]),
    testimonial: {
      name: "Chef Rohit Sinha",
      role: "Owner",
      company: "The Spice Route, Hyderabad",
      quote: "Our reservation process is now fully automated. AI takes bookings, manages waitlists, sends reminders, and even upsells wine pairings. Revenue per cover went up 28%.",
      avatar: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=100&h=100&fit=crop&auto=format"
    }
  },
  police: {
    id: "police",
    label: "Police",
    emoji: "\u{1F46E}",
    color: "#1d4ed8",
    bgLight: "#eff6ff",
    tagline: "AI for Law Enforcement & Government",
    supportHeadline: "AI Public Safety Assistant",
    supportFeatures: ["Complaint Registration AI", "FIR Status Updates", "Emergency Dispatch Routing", "Lost & Found Chatbot", "Public Safety Alerts", "Warrant Verification", "Traffic Violation Queries", "Citizen Service Portal"],
    surveillanceHeadline: "AI-Powered Security Network",
    surveillanceFeatures: ["CCTV Network Analytics", "Face Recognition at Checkpoints", "Crowd Anomaly Detection", "Vehicle License Plate Recognition", "Threat Assessment AI", "Perimeter Breach Alerts", "Incident Heat Mapping", "Evidence Management System"],
    workflow: [
      { label: "Citizen Reports", icon: "\u{1F4E2}", desc: "Complaint, emergency, or query submitted" },
      { label: "AI Triages", icon: "\u{1F6A8}", desc: "Urgency level assessed; routed correctly" },
      { label: "Case Registered", icon: "\u{1F4CB}", desc: "FIR or complaint auto-registered in system" },
      { label: "Officer Dispatched", icon: "\u{1F694}", desc: "Nearest unit alerted with location & details" },
      { label: "On-site Response", icon: "\u{1F50D}", desc: "Officer responds; AI logs activity" },
      { label: "Investigation Tracked", icon: "\u{1F4CA}", desc: "Real-time case status updated & shared" },
      { label: "Resolution & Report", icon: "\u2705", desc: "Case closed; citizen notified with reference" }
    ],
    metrics: [
      { label: "Daily Complaints Handled", value: "8,400", sub: "98.6% logged correctly", positive: true, color: "#1d4ed8" },
      { label: "Response Time", value: "4.2 min", sub: "\u221268% faster", positive: true, color: "#8b5cf6" },
      { label: "Detection Accuracy", value: "99.1%", sub: "Face recognition", positive: true, color: "#10b981" },
      { label: "Case Resolution", value: "+44%", sub: "Year over year", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([6800, 7400, 8400, 7800, 10200, 9800, 9200], [6400, 7e3, 8100, 7500, 9900, 9500, 8900]),
    testimonial: {
      name: "Commissioner S. Rao",
      role: "Police Commissioner",
      company: "Hyderabad Metropolitan Police",
      quote: "AI-powered surveillance and complaint routing transformed our response times. We now handle 8,400 citizen interactions per day with minimal manual intervention.",
      avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=100&h=100&fit=crop&auto=format"
    }
  },
  manufacturing: {
    id: "manufacturing",
    label: "Manufacturing",
    emoji: "\u{1F3ED}",
    color: "#64748b",
    bgLight: "#f8fafc",
    tagline: "AI for Manufacturing & Warehouses",
    supportHeadline: "AI Operations Command",
    supportFeatures: ["Production Query Handling", "Supplier Communication AI", "Quality Issue Escalation", "Maintenance Request Routing", "Inventory Status Queries", "Shift Scheduling Assistant", "Compliance Documentation AI", "Export & Logistics Queries"],
    surveillanceHeadline: "Smart Factory Surveillance",
    surveillanceFeatures: ["Worker Safety Monitoring", "PPE Detection & Alerts", "Machine Anomaly Detection", "Inventory Zone Tracking", "Unauthorized Access Alerts", "Forklift Safety AI", "Quality Control Vision", "Production Line Analytics"],
    workflow: [
      { label: "Production Order", icon: "\u{1F4CB}", desc: "Order received and digitally processed" },
      { label: "AI Plans", icon: "\u{1F916}", desc: "AI schedules machines, staff & materials" },
      { label: "Line Activated", icon: "\u2699\uFE0F", desc: "Production begins with AI oversight" },
      { label: "Quality Check", icon: "\u{1F50D}", desc: "Computer vision inspects every unit" },
      { label: "Defect Flagged", icon: "\u{1F6A8}", desc: "Anomalies caught & escalated instantly" },
      { label: "Shipment Ready", icon: "\u{1F4E6}", desc: "QA passed; dispatch triggered" },
      { label: "Delivery Confirmed", icon: "\u2705", desc: "GPS tracked; client notified" }
    ],
    metrics: [
      { label: "Units Monitored/Day", value: "42,800", sub: "Zero manual checks", positive: true, color: "#64748b" },
      { label: "Defect Detection", value: "99.4%", sub: "Precision accuracy", positive: true, color: "#8b5cf6" },
      { label: "Downtime Reduction", value: "\u221272%", sub: "Predictive maintenance", positive: true, color: "#10b981" },
      { label: "Safety Incidents", value: "\u221284%", sub: "Via PPE AI alerts", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([38e3, 41e3, 42800, 4e4, 5e4, 48e3, 46e3], [36e3, 39e3, 41e3, 38e3, 48e3, 46e3, 44e3]),
    testimonial: {
      name: "Harish Gupta",
      role: "Plant Director",
      company: "AutoParts India Ltd, Chennai",
      quote: "AI surveillance caught safety violations we'd never detect manually. Defect rates dropped 68% and downtime is almost zero. Orryworx AI paid for itself in 3 months.",
      avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&auto=format"
    }
  },
  realestate: {
    id: "realestate",
    label: "Real Estate",
    emoji: "\u{1F3E0}",
    color: "#059669",
    bgLight: "#ecfdf5",
    tagline: "AI for Real Estate & Property",
    supportHeadline: "AI Property Assistant",
    supportFeatures: ["Property Inquiry Handling", "Site Visit Scheduling", "Loan Eligibility Chatbot", "Pricing Query AI", "CRM Auto-update", "Lead Qualification & Scoring", "WhatsApp Property Tours", "Follow-up Automation"],
    surveillanceHeadline: "Property & Site Surveillance",
    surveillanceFeatures: ["Construction Site Monitoring", "Unauthorized Entry Detection", "Material Theft Prevention", "Worker Safety Tracking", "Night Patrol AI", "Community Security", "Visitor Log Automation", "Perimeter Alerts"],
    workflow: [
      { label: "Lead Inquiry", icon: "\u{1F3E0}", desc: "Call, WhatsApp, or website property interest" },
      { label: "AI Qualifies", icon: "\u{1F916}", desc: "Budget, timeline & preferences collected" },
      { label: "Properties Matched", icon: "\u{1F5FA}\uFE0F", desc: "AI recommends best-fit listings" },
      { label: "Site Visit Booked", icon: "\u{1F4C5}", desc: "Schedule confirmed with sales agent" },
      { label: "Visit Conducted", icon: "\u{1F440}", desc: "Virtual or physical tour with AI-assisted info" },
      { label: "Offer Negotiated", icon: "\u{1F91D}", desc: "AI assists with pricing & documentation" },
      { label: "Deal Closed", icon: "\u{1F511}", desc: "Agreement signed; handover scheduled" }
    ],
    metrics: [
      { label: "Leads This Month", value: "3,240", sub: "+52% conversion rate", positive: true, color: "#059669" },
      { label: "AI Interactions", value: "22,400", sub: "96.8% automated", positive: true, color: "#8b5cf6" },
      { label: "Site Visits Booked", value: "680", sub: "+38% vs manual", positive: true, color: "#10b981" },
      { label: "Deal Closure Time", value: "\u221244%", sub: "Faster with AI", positive: true, color: "#a855f7" }
    ],
    chartData: chartWeek([2600, 2900, 3240, 3e3, 4e3, 3800, 3600], [2440, 2720, 3060, 2840, 3800, 3620, 3420]),
    testimonial: {
      name: "Aditya Bhatt",
      role: "MD",
      company: "Prestige Properties, Bengaluru",
      quote: "Our sales team now focuses only on hot leads\u2014AI qualifies, follows up, and schedules visits automatically. We closed 52% more deals this quarter.",
      avatar: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=100&h=100&fit=crop&auto=format"
    }
  }
};
const ALL_INDUSTRIES = [
  { id: "doctor", label: "Doctors", emoji: "\u{1FA7A}", group: "doctor" },
  { id: "dentist", label: "Dentists", emoji: "\u{1F9B7}", group: "dentist" },
  { id: "hospital", label: "Hospitals", emoji: "\u{1F3E5}", group: "hospital" },
  { id: "clinic", label: "Clinics", emoji: "\u{1FA79}", group: "doctor" },
  { id: "bus", label: "Bus Operators", emoji: "\u{1F68C}", group: "bus" },
  { id: "transport", label: "Transport Co.", emoji: "\u{1F69B}", group: "bus" },
  { id: "school", label: "Schools", emoji: "\u{1F3EB}", group: "school" },
  { id: "college", label: "Colleges", emoji: "\u{1F393}", group: "school" },
  { id: "hotel", label: "Hotels", emoji: "\u{1F3E8}", group: "hotel" },
  { id: "restaurant", label: "Restaurants", emoji: "\u{1F37D}\uFE0F", group: "restaurant" },
  { id: "retail", label: "Retail Stores", emoji: "\u{1F6D2}", group: "retail" },
  { id: "bank", label: "Banks", emoji: "\u{1F3E6}", group: "bank" },
  { id: "police", label: "Police", emoji: "\u{1F46E}", group: "police" },
  { id: "government", label: "Government", emoji: "\u{1F3DB}\uFE0F", group: "police" },
  { id: "manufacturing", label: "Manufacturing", emoji: "\u{1F3ED}", group: "manufacturing" },
  { id: "warehouse", label: "Warehouses", emoji: "\u{1F4E6}", group: "manufacturing" },
  { id: "beauty", label: "Beauty Parlours", emoji: "\u{1F484}", group: "salon" },
  { id: "salon", label: "Salons", emoji: "\u2702\uFE0F", group: "salon" },
  { id: "gym", label: "Gyms", emoji: "\u{1F3CB}\uFE0F", group: "salon" },
  { id: "realestate", label: "Real Estate", emoji: "\u{1F3E0}", group: "realestate" },
  { id: "logistics", label: "Logistics", emoji: "\u{1F69A}", group: "bus" },
  { id: "insurance", label: "Insurance", emoji: "\u{1F6E1}\uFE0F", group: "bank" }
];
function getIndustryData(industryId) {
  const entry = ALL_INDUSTRIES.find((i) => i.id === industryId);
  const group = entry?.group ?? industryId;
  return INDUSTRY_DATA[group] ?? INDUSTRY_DATA["doctor"];
}
export {
  ALL_INDUSTRIES,
  INDUSTRY_DATA,
  getIndustryData
};
